import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import UserLayout from "../pages/user/UserLayout";
import { ROLES } from "../core/constants";

export default function UserRoutes() {
    const { auth, isAuthenticated } = useAuth();
    const location = useLocation();

    const checkRole = () => {
        return (
            // auth.admin_level_cd === ROLES.Volunteer ||
            auth.admin_level_cd === ROLES.Distributor ||
            auth.admin_level_cd === ROLES.User ||
            auth.admin_level_cd === ROLES.BranchManager ||
            auth.admin_level_cd === ROLES.Agency
        );
    };

    return checkRole() ? (
        <UserLayout>
            <Outlet />
        </UserLayout>
    ) : isAuthenticated ? (
        <Navigate to={"/unauthorized"} state={{ from: location }} replace />
    ) : (
        <Navigate to={"/"} state={{ from: location }} replace />
    );
}
